





























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import {
  ECustomerInactivityStepSlug,
  ICustomerInactivityFormData
} from '@/models/customer-inactivity';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RadioGroupWithCustom, {
  IOption,
  RadioGroupWithCustomVariant
} from '@/componentsV2/molecules/Inputs/RadioGroupWithCustom.vue';
import customerInactivity from '@/constants/customerInactivity';

let timer: NodeJS.Timeout;

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    RadioGroupWithCustom,
    FilledButton
  }
})
export default class CustomerInactivityForm extends Vue {
  @Prop({ default: 'md' }) variant?: RadioGroupWithCustomVariant;
  @Prop({ default: false }) loading?: boolean;
  @Prop() customerInactiveFormData!: ICustomerInactivityFormData;

  ECustomerInactivityStepSlug = ECustomerInactivityStepSlug;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get customerInactivityDaysConfig() {
    return this.businessInfo.inactiveCustomerDays;
  }

  get customerInacivityOptions(): IOption<number | undefined>[] {
    return [
      {
        slug: '14Days',
        label: '14 days',
        value: 14
      },
      {
        slug: '30Days',
        label: '30 days',
        value: 30
      },
      {
        slug: '60Days',
        label: '60 days',
        value: 60
      },
      {
        slug: 'customerInactiveCustomDays',
        label: 'Custom (days)',
        requiredCustomValue: true,
        value: undefined
      }
    ];
  }

  beforeDestroy() {
    if (timer) clearTimeout(timer);
  }

  mounted() {
    if (!this.customerInactiveFormData.slug) this.getDefaultFormData();
  }

  getDefaultFormData() {
    const numberOfDays =
      this.customerInactivityDaysConfig || customerInactivity.DEFAULT_DAYS;

    const optionByValue = this.customerInacivityOptions.find(
      ({ value }) => value === numberOfDays
    );

    const slug = optionByValue
      ? optionByValue.slug
      : 'customerInactiveCustomDays';

    Object.assign(this.customerInactiveFormData, {
      slug,
      value:
        this.customerInactivityDaysConfig || customerInactivity.DEFAULT_DAYS
    });
  }

  setInputFocus(slug: string) {
    timer = setTimeout(() => {
      const containerEl = document.getElementById(slug)!;
      const inputEl = containerEl.querySelector('input');

      if (inputEl) inputEl.focus();
    }, 0);
  }

  handleToggle(slug: string) {
    const formRef = this.$refs.observer;
    formRef.reset();

    if (this.customerInactiveFormData.slug !== slug) {
      const selectedOption = this.customerInacivityOptions.find(
        option => option.slug === slug
      );

      if (selectedOption) {
        Object.assign(this.customerInactiveFormData, {
          slug: selectedOption.slug,
          value: selectedOption.value
        });

        this.setInputFocus(selectedOption.slug);
      }
    }
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');
      return;
    }

    this.$emit('submit', this.customerInactiveFormData);
  }
}
